import i18n from '@/localization/localization';

export type ValidationAlias = string;

export interface ValidationFields {
    [key: string]: ValidationAlias[];
}

export interface ValidationError {
    key: string;
    message: string;
}

export interface ValidationResult {
    success: boolean;
    errors: ValidationError[];
}

export type ValidationMethod = (input: any, key?: string) => ValidationMethodResult;

export interface ValidationMethodResult {
    success: boolean;
    message?: string;
}

export class Validator {
    public static addMethod(alias: ValidationAlias, method: ValidationMethod) {
        Validator.methods[alias] = method;
    }

    public static validate(alias: ValidationAlias, input: any, key = ''): ValidationMethodResult {
        if (!(alias in Validator.methods)) {
            console.warn('Validation: could not find validator with alias', alias);

            return {
                success: false,
            };
        }

        const translatedKey = i18n.t('validation.fields.' + key).toString();

        return Validator.methods[alias](input, translatedKey);
    }
    private static methods: {
        [key: string]: ValidationMethod;
    } = {};
}
